export const removeRootParagraph = (text: string) => {
    return text.replace(/^<p>/, '').replace(/<\/p>$/, '');
};
